import {
  type CreateOrUpdateTravelerResponse,
  type ListTravelersResponse,
  type Traveler,
  travelerApi as travelerAxiosApi,
} from "@b2bportal/traveler-api";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

export const handleAxiosError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status ?? 500;
    const data = error.response?.data ?? error.message;
    return { type: "network", error: { status, data } };
  }

  return {
    error: { type: "unknown" },
  };
};

export const travelerApi = createApi({
  reducerPath: "traveler",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["TravelerList"],
  endpoints: (builder) => ({
    getTravelers: builder.query<ListTravelersResponse, void>({
      queryFn: async () => {
        try {
          const response = await travelerAxiosApi(axios).apiV0TravelerListPut(
            {}
          );
          return { data: response.data };
        } catch (error) {
          return { error: handleAxiosError(error) };
        }
      },
      providesTags: ["TravelerList"],
    }),
    updateTraveler: builder.mutation<CreateOrUpdateTravelerResponse, Traveler>({
      queryFn: async (traveler) => {
        try {
          const response = await travelerAxiosApi(axios).apiV0TravelerPut({
            traveler,
          });
          return { data: response.data };
        } catch (error) {
          return { error: handleAxiosError(error) };
        }
      },
      invalidatesTags: ["TravelerList"],
    }),
    deleteTraveler: builder.mutation<void, Traveler>({
      queryFn: async (traveler) => {
        try {
          await travelerAxiosApi(axios).apiV0TravelerDeletePut({
            travelerId: traveler.id,
          });
          return { data: undefined };
        } catch (error) {
          return { error: handleAxiosError(error) };
        }
      },
      invalidatesTags: ["TravelerList"],
    }),
  }),
});
